import React from "react";
import styled from "styled-components";
import CarAvatar from "../../images/car_avatar.png";

const CarImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CarImageComponent = props => {
  return (
    <CarImage>
      <img style={{ width: 100 }} src={props.url ? props.url : CarAvatar} />
    </CarImage>
  );
};

export default CarImageComponent;
